module.exports = __webpack_public_path__ + "static/img/bot_line.3ea33c32.png";